import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SymptomCardProps {
  name: string
  checked: boolean
  onToggle: () => void
}

export function SymptomCard({ name, checked, onToggle }: SymptomCardProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={cn(
        'group w-full flex items-center gap-3 rounded-xl border-2 px-3.5 py-3 text-left transition-all select-none',
        checked
          ? 'border-primary bg-primary/15 shadow-soft'
          : 'border-border bg-card hover:border-primary/50 hover:bg-primary/5 hover:-translate-y-px hover:shadow-soft'
      )}
    >
      <span
        className={cn(
          'flex items-center justify-center h-[18px] w-[18px] rounded-[5px] border-2 transition-all shrink-0',
          checked ? 'bg-primary border-primary text-primary-foreground' : 'border-border bg-card'
        )}
      >
        {checked && <Check className="h-3 w-3" strokeWidth={3} />}
      </span>
      <span className={cn('text-sm leading-tight', checked ? 'text-coentro font-semibold' : 'text-foreground')}>{name}</span>
    </button>
  )
}
